import {Component, Input, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import moment from 'moment';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {OnlyNumberDirective} from '@app/shared/directive';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {ToastrService} from 'ngx-toastr';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-medicine',
  templateUrl: './medicine.component.html',
  styleUrls: ['./medicine.component.scss', './medicine.component.scss'],
  animations: [routerTransition()],
  imports: [FormsModule, CommonModule, NgbPaginationModule, OnlyNumberDirective, PageHeaderComponent, PaginationComponent],
})
export class MedicineComponent implements OnInit {
  @Input() assessment_id = 0;
  @Input() patient_id = 0;
  public now = new Date();
  public date: any;
  public user_rights: any = {};
  public medi_data: any = [];
  public index = 0;
  public checked = false;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  public user_data: any = {};
  public medicine_data: any =
    {
      ddc_code: '',
      trade_name: '',
      scientific_code: '',
      scientific_name: '',
      ingredient_strength: '',
      dosage_from_package: '',
      route_of_admin: '',
      user_id: '',
      package_price: '',
      granular_unit: '',
      manufacturer: '',
      registered_owner: '',
      source: '',
      unit: '',
      product_code: '',
      search_medicine: '',
      safty_stock: '',
      reorder: '',
      location: '',
      vat: "",
      hsn_code: "",
      medicine_id: 0,
      category: 0,
    }
  status: any;
  unit: any;
  data_id = 0;
  category: any;
  searching = false;
  searchFailed = false;

  constructor(private loaderService: LoaderService, public consultingService: ConsultingService, private toastr: ToastrService,) {
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getMedicineList();
    this.getUnitList();
    this.listCategory();
    this.medicine_data.user_id = this.user_data.user_id;
    this.formatDateTime();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public saveMedicine() {
    if (!(this.medicine_data.trade_name)) {
      this.toastr.error('Please Enter the trade name!');
    } else if (!(this.medicine_data.unit)) {
      this.toastr.error('Please please select unit!');
    } else {
      const postData = {
        user_id: this.user_data.user_id,
        medicine_id: this.medicine_data.medicine_id,
        category: this.medicine_data.category,
        product_code: this.medicine_data.product_code,
        ddc_code: this.medicine_data.ddc_code,
        trade_name: this.medicine_data.trade_name,
        scientific_code: this.medicine_data.scientific_code,
        scientific_name: this.medicine_data.scientific_name,
        ingredient_strength: this.medicine_data.ingredient_strength,
        dosage_from_package: this.medicine_data.dosage_from_package,
        route_of_admin: this.medicine_data.route_of_admin,
        package_price: this.medicine_data.package_price,
        granular_unit: this.medicine_data.granular_unit,
        manufacturer: this.medicine_data.manufacturer,
        registered_owner: this.medicine_data.registered_owner,
        source: this.medicine_data.source,
        unit: this.medicine_data.unit,
        safty_stock: this.medicine_data.safty_stock,
        reorder: this.medicine_data.reorder,
        location: this.medicine_data.location,
        vat: this.medicine_data.vat,
        hsn_code: this.medicine_data.hsn_code,
        check: this.checked,
        data_id: this.data_id
      }
      this.loaderService.display(true);
      this.consultingService.saveMedicine(postData).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.getMedicineList();
          this.clearMedicine();
          this.toastr.success(result["msg"]);
          this.index = result.data_id;
        } else {
          this.toastr.error(result["msg"]);
        }
        this.loaderService.display(false);
      })
    }
  }

  public clearMedicine() {
    this.medicine_data = {
      ddc_code: '',
      trade_name: '',
      scientific_code: '',
      scientific_name: '',
      ingredient_strength: '',
      dosage_from_package: '',
      route_of_admin: '',
      user_id: '',
      package_price: '',
      granular_unit: '',
      manufacturer: '',
      registered_owner: '',
      source: '',
      unit: '',
      search_medicine: '',
      vat: "",
      hsn_code: "",
      product_code: "",
      medicine_id: 0,
      category: 0
    }
    this.checked = false
    this.getMedicineList();
  }

  public getUnitList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      unit_id: ""
    };
    this.loaderService.display(true);
    this.consultingService.listUnit(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.unit = result['data'];
      } 
      this.loaderService.display(false);
    });
  }

  public listCategory() {
    this.loaderService.display(true);

    this.consultingService.listCategory().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.category = result['data'];
      }
    });
  }

  public editMedicine(meddata: any) {
    this.medicine_data.product_code = meddata.PRODUCT_CODE;
    this.medicine_data.safty_stock = meddata.SAFTY_STOCK;
    this.medicine_data.reorder = meddata.REORDER_QUANTITY;
    this.medicine_data.location = meddata.LOCATION;
    this.medicine_data.ddc_code = meddata.DDC_CODE;
    this.medicine_data.trade_name = meddata.TRADE_NAME;
    this.medicine_data.scientific_code = meddata.SCIENTIFIC_CODE;
    this.medicine_data.scientific_name = meddata.SCIENTIFIC_NAME;
    this.medicine_data.ingredient_strength = meddata.INGREDIENT_STRENGTH;
    this.medicine_data.dosage_from_package = meddata.DOSAGE_FORM_PACKAGE;
    this.medicine_data.route_of_admin = meddata.ROUTE_OF_ADMIN;
    this.medicine_data.package_price = meddata.PACKAGE_PRICE;
    this.medicine_data.granular_unit = meddata.GRANULAR_UNIT;
    this.medicine_data.manufacturer = meddata.MANUFACTURER;
    this.medicine_data.registered_owner = meddata.REGISTERED_OWNER;
    this.medicine_data.source = meddata.SOURCE;
    this.medicine_data.unit = meddata.UNIT;
    this.medicine_data.vat = meddata.VAT;
    this.medicine_data.hsn_code = meddata.HSN_CODE;
    this.medicine_data.medicine_id = meddata.MEDICINE_ID;
    this.medicine_data.category = meddata.CATEGORY;
    this.checked = true
    window.scrollTo(0, 0);
  }
  
  public getMedicineList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      medicine_id: '0',
      data_id: this.data_id,
    };

    this.loaderService.display(true);
    this.consultingService.listMedicine(postData).subscribe((result: any) => {
      this.medicine_data.product_code = result['product_code']['data']
      if (result['status'] == 'Success') {
        this.medi_data = result['data'];
        this.collection = result['total_count'];
      } else {
        this.medi_data = [];
        this.collection = 0;
      }
       this.loaderService.display(false);
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.medicine_data.search_medicine,
      medicine_id: '0'
    };
    this.loaderService.display(true);
    if (postData.search_text.length > 2) {
      this.consultingService.listMedicine(postData).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.medi_data = result['data'];
          this.collection = result['total_count'];
          const i = this.medi_data.length;
          this.index = i + 5;
          this.status = result['status'];
        } else {
          this.collection = 0;
          this.status = result['status'];
        }
      this.loaderService.display(false);
      });
    } else {
      this.loaderService.display(false);

    }
  }

  public formatDateTime() {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
  }

  public clear_search() {
    if (this.medicine_data.search_medicine != '') {
      this.clearMedicine();
      this.getMedicineList();
    }
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.consultingService.medicine_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: {
    TRADE_NAME: string,
    MEDICINE_ID: number,
    SCIENTIFIC_CODE: string,
    SCIENTIFIC_NAME: string,
    DDC_CODE: string
  }) => x.TRADE_NAME;

  deleteMedicine(med_id:any){
    const confirmed = confirm('Are you sure you want to delete this item?');
    if (confirmed) {
      this.loaderService.display(true);
      this.consultingService.deleteMedicineItem({medicine_id : med_id}).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.getMedicineList();
          this.toastr.success(result["msg"]);
        }else{
          this.toastr.error(result["msg"]);
        }
        this.loaderService.display(false);
      });
    }
  }
}
